import { type FieldContentsData } from 'javascripts/shared-types';
import Field, { type Flavor } from '../../Field';
import terminology from 'javascripts/terminology';
import moment from 'moment';
import { dateFormattedWithUserLocale } from 'javascripts/util/dateFns';

export class TeamIteration extends Field {
  static get availableForFlavors(): readonly Flavor[] {
    return ['develop', 'teamwork'];
  }

  static subqueriesForModel() {
    return { iteration: ['name', 'startDate', 'duration'] };
  }

  get title() {
    return terminology('Iteration');
  }

  exampleContents(): FieldContentsData {
    return {
      text: `${terminology('Iteration')} 1 (ends ${dateFormattedWithUserLocale(
        moment()
      )})`,
    };
  }

  contentsForRecord(record): FieldContentsData {
    if (record.iteration) {
      return {
        text: `${record.iteration.name} (ends ${dateFormattedWithUserLocale(
          record.iteration.endDate
        )})`,
      };
    }

    return {};
  }
}
